<template>
  <template v-if="detailedEntity">
    <div class="flex flex-wrap items-start mt-4 px-3 gap-4">
      <Card class="w-full"
        ><template #title>{{ entity.firstName }} {{ entity.lastName }}</template>
        <template #subtitle>{{ entity.companyName }}</template>
        <template #content
          ><div>
            <span class="font-bold">Phone: </span><span>{{ entity.extension }} {{ entity.entityPhone }}</span>
          </div>
          <div>
            <span class="font-bold">E-mail: </span><span>{{ entity.email }}</span>
          </div></template
        ><template #footer>
          <div class="flex gap-1">
            <Tag v-if="entity.active" icon="pi pi-check" severity="success" value="Active"></Tag>
            <Tag v-else icon="pi pi-times" severity="danger" value="Inactive"></Tag>
            <Tag v-if="entity.user" icon="pi pi-user" severity="info" value="User"></Tag>
            <Tag v-if="entity.licensee" severity="info" value="Licensee"></Tag>
            <Tag v-if="entity.primaryLender" icon="pi pi-money-bill" severity="info" value="Primary Lender"></Tag>
            <Tag v-if="entity.send1099s" icon="pi pi-envelope" severity="info" value="Send 1099s"></Tag>
            <Tag v-if="entity.webAccountStatus" icon="pi pi-globe" severity="info" :value="entity.webAccountStatus"></Tag>
            <Tag v-if="entity.webAccountReadOnly" icon="pi pi-book" severity="warning" value="Web Read Only"></Tag>
          </div>
        </template>
      </Card>
      <Tabs class="w-full border-surface-100 border-1 border-t-0 dark:border-surface-900 rounded-b-lg shadow" value="0">
        <TabList>
          <Tab value="0">Address</Tab>
          <Tab value="1">Banking</Tab>
          <Tab value="2">Projects</Tab>
          <Tab value="3">Documents</Tab>
        </TabList>
        <TabPanels>
          <TabPanel value="0">
            <div class="flex flex-col">
              <span>{{ entity.addressLine1 }}</span>
              <span>{{ entity.addressLine2 }}</span>
              <span>{{ entity.city }}</span>
              <span>{{ entity.state }}</span>
              <span>{{ entity.zip }}</span>
            </div>
          </TabPanel>
          <TabPanel value="1">
            <div class="flex flex-col">
              <span>{{ entity.bankName }}</span>
              <span>{{ entity.bankCity }}</span>
              <span>{{ entity.bankABANumber }}</span>
              <span>{{ entity.bankNumber }}</span>
              <span>{{ entity.bankAccount }}</span>
            </div>
          </TabPanel>
          <TabPanel value="2">
            <div class="max-h-[250px] overflow-scroll">
              <div v-for="project in detailedEntity.projects">
                <div class="flex flex-row gap-3">
                  <Tag :severity="getProjectStatusSeverity(project.projectStatus.category)" class="w-20">{{ project.projectStatus.name }}</Tag>
                  <p>{{ project.projectCode }} - {{ project.projectName }}</p>
                </div>

                <Divider class="my-3!"></Divider>
              </div>
            </div>
          </TabPanel>
          <TabPanel value="3">
            <FileManager :file-entity-type="FileEntity.ENTITY" :files-url="entityFilesUrl" upload-mode="basic" />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  </template>
  <template v-else
    ><div class="flex flex-col w-full">
      <ProgressSpinner style="width: 100px; height: 100px" class="fill-surface-0 dark:fill-surface-800 mx-auto" animationDuration=".5s" /></div
  ></template>
</template>

<script setup lang="ts">
import { EntityDetailSchema, type Entity, type EntityDetail } from "@/types/Entity";
import type { ApiError } from "@/types/Response";
import FileManager from "../FileManager.vue";
import { FileEntity } from "@/enums/FileEntity";
import { getProjectStatusSeverity } from "@/enums/ProjectStatusCategory";

interface Props {
  entity: Entity;
}

const props = defineProps<Props>();
const detailedEntity = ref<EntityDetail>();

const entityFilesUrl = computed<string>(() => {
  return `/entities/${props.entity.entityId}/files`;
});

onBeforeMount(async (): Promise<void> => {
  await axios
    .get(`/entities/detail/${props.entity.entityId}`)
    .then((response) =>
      handleApiResponse(
        response,
        (data: any) => {
          parseData(EntityDetailSchema, data, detailedEntity);
        },
        (errors: ApiError[]) => {
          error("An error occurred", errors[0].message);
        }
      )
    )
    .catch((e) => errorApi(e));
});
</script>
